import { defineMessages } from '@jutro/locale';

export default defineMessages({
    failedToGetPatientData: {
        id: 'claim.views.claim-cw.Please try again later',
        defaultMessage: 'Please try again later or contact our ADAC Ambulance-Service using the below phone number: +49 89 767676'
    },
    ebsFailed: {
        id: 'claim.views.claim-cw.Ebs failed',
        defaultMessage: 'Failed to sign the document.\nPlease try again later or contact our ADAC Ambulanze-Service using the below phone number:  +49 89 767676.'
    },
    fetchFailedTitle: {
        id: 'claim.views.claim-cw.Claim Details',
        defaultMessage: 'Claim Details'
    },
    submittedSuccessfully: {
        id: 'claim.views.claim-cw.Submitted successfully',
        defaultMessage: 'Submitted successfully'
    },
    close: {
        id: 'claim.views.claim-cw.Close',
        defaultMessage: 'Close'
    },
    signtTheDocumentButton: {
        id: 'claim.views.claim-cw.Sign the document',
        defaultMessage: 'Sign the document'
    },
    correctSignatureButton: {
        id: 'claim.views.claim-cw.Correct the signature',
        defaultMessage: 'Correct the signature'
    },
    sendButton: {
        id: 'claim.views.claim-cw.Send',
        defaultMessage: 'Send'
    },
    signatureNotice: {
        id: 'claim.views.claim-cw.Signature of the patient / legal representative',
        defaultMessage: 'Signature of the patient / legal representative'
    },
    consentMandatory: {
        id: 'claim.views.claim-cw.This consent is mandatory',
        defaultMessage: 'This consent is mandatory'
    },
    accordionTitle: {
        id: 'claim.views.claim-cw.Accordion Title',
        defaultMessage: 'Detailed information'
    },
    errorMandatoryFields: {
        id: 'claim.views.claim-cw.Please fill all of the mandatory data',
        defaultMessage: 'Please fill all of the mandatory data.'
    },
    signatureInfo: {
        id: 'claim.views.claim-cw.Signature info',
        defaultMessage: 'If the consent under data protection law and the release from the duty of confidentiality is required in a foreign language, your signature also applies to the translated version of these declarations.'
    },
    signedDocumentInfo: {
        id: 'claim.views.claim-cw.The signed document will be sent to the email',
        defaultMessage: 'The signed document will be sent to the email address provided in the claim application.'
    }
});
